import create from 'zustand';
import authStore from './authStore';

const useAuthStore = create(authStore);

export default useAuthStore;
